export function getBrowser() {
  if (/MicroMessenger/.test(window.navigator.userAgent)) {
    return 'wechat';
  }

  if (/AlipayClient/.test(window.navigator.userAgent)) {
    return 'alipay';
  }

  return 'other';
}